import PatientStub from '../../components/PatientStub.jsx'
export default function PatientProfile() { return <PatientStub title="โปรไฟล์" /> }
